import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const welcomeBody = `You have received this notification from Desert Sage Seminars because you are a registered user. You have successfully registered with Desert Sage Seminars. PLEASE SAVE THIS EMAIL FOR YOUR RECORDS.
Your Username and Password will enable you to enroll in our courses at any time.
Your Username is as follows:

Username: username

Please remember that the Password you created is case sensitive.

You affirmed the following to be true:
  • I will be the person taking these classes, and
  • I realize that it is a felony to impersonate a real estate licensee
  • I will not complete more than 9 renewal hours within the same calendar day

At any time while taking a course, you will be able to contact Tech Support* should you encounter a problem with our website, or Course Support* should you encounter any issues with the course, the text, quizzes or anything course related.
* Support will be available 7 days a week from 7:30 AM to 9:00 PM Arizona time.
Thank you for registering with Desert Sage Seminars. We are sure you will find our courses to be an efficient and valuable use of your time.

Cordially

Jon Kichen, Instructor
Owner/Administrator
Desert Sage Seminars
Phone: 602-377-6207
URL: www.DesertSageSeminars.com`;
export function EditEmailDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-757" data-mp="7p2odmiy3ze2">
      <div className="flex items-center justify-between" data-id="element-758" data-mp="mk8sg3yhdo4r">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-759" data-mp="mhmn8az2bkpp">Edit Email Detail</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/email-details')} data-id="element-760" data-mp="hlnpvxvrasd5">
          ← Back to Email Details
        </Button>
      </div>

      <Card data-id="element-761" data-mp="3927ovyw37l9g">
        <CardContent className="pt-6" data-id="element-762" data-mp="392r6tflqm9nh">
          <form className="space-y-5 max-w-2xl" data-id="element-763" data-mp="3d183f57j81qn">
            <Input label="Subject" defaultValue="Welcome to Desert Sage Seminars" data-id="element-764" data-mp="3d42o8xugjokl" />

            <div data-id="element-765" data-mp="3mzw872aiakce">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-766" data-mp="3n0fpqhw8v6pw">
                Body
              </label>
              <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-767" data-mp="3ryh9l51hva2f">
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-768" data-mp="3vzsp2hqnmeww">
                  <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-769" data-mp="4mq17k49vgey">
                    Source
                  </button>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-770" data-mp="jixkmi7uwdt6" />
                  {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-771" data-mp="2432opp4mhvyy" data-mpi={i}>
                      {ic}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-772" data-mp="1p6le5049cldg" />
                  {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-773" data-mp="2hsctol6x3hs0" data-mpi={i}>
                      {ic}
                    </button>)}
                </div>
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-774" data-mp="35js28vpaevbp">
                  {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-775" data-mp="2l8xvh25qezfc">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-776" data-mp="2gawd6jg4r44x" />
                  {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-777" data-mp="38zbq90fpbcdm" data-mpi={i}>
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-778" data-mp="3mzcpyck8cdri" />
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-779" data-mp="3mwzz19whut2b">
                    <option data-id="element-780" data-mp="3rrw3j9ix38wb">Styles</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-781" data-mp="1g9j5p5x4x4zo">
                    <option data-id="element-782" data-mp="1bay4p4a26ha6">Format</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-783" data-mp="1q15desa9klxo">
                    <option data-id="element-784" data-mp="1l10vcxtpjj5c">Font</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-785" data-mp="1l3nbhlunz6z6">
                    <option data-id="element-786" data-mp="xe2jyekg31ea">Size</option>
                  </select>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-787" data-mp="se6nr1hzoe9a" />
                  {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-788" data-mp="16ajxtpk71ddq" data-mpi={i}>
                      {t}
                    </button>)}
                </div>
                <textarea className="w-full p-3 text-sm focus:outline-none resize-y min-h-[200px] bg-white" defaultValue={welcomeBody} data-id="element-789" data-mp="1afu05d936t8c" />
              </div>
            </div>

            <div className="pt-2 flex items-center gap-4" data-id="element-790" data-mp="1ketb52hbr0yi">
              <Button type="submit" data-id="element-791" data-mp="1oetmge94mw1c">Submit</Button>
            </div>
          </form>

          <div className="mt-6 pt-4 border-t border-slate-200 space-y-1" data-id="element-792" data-mp="rot2qtnm75qw">
            <p className="text-sm font-medium text-slate-700" data-id="element-793" data-mp="rqnoga6pn1w1">Actions</p>
            <div className="flex flex-col gap-1 text-sm text-blue-600" data-id="element-794" data-mp="wop7iv44z17i">
              <button className="text-left hover:underline text-red-500 w-fit" data-id="element-795" data-mp="10ozas00jndio">
                Delete
              </button>
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details')} data-id="element-796" data-mp="15h0x6erfekmf">
                List Email Details
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}